import { h } from 'preact'

interface Props {
  role: string
}

const RoleCell = () => {
  return ({ role }: Props) => {
    return (
      <div className='team-overview__table-role'>
        { role }
      </div>
    )
  }
}

export default RoleCell
